import React from 'react'
import Halls from '../components/Halls'

const HallsPage = () => <Halls /> 


export default HallsPage
